import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            六大核心优势，值得您的信赖
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            从安全认证到用户体验，008pg国际在每个细节都追求卓越，为您打造值得信赖的国际平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-2xl hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-primary-600 group-hover:text-background-50 text-xl transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}